import fetch from '@/utils/fetch'

// 代理商列表
export function getBuyAndSendList(params) {
  return fetch({
    url: `/buytosend/lists`,
    method: 'get',
    params
  })
}

export function getBuyAndSendInfo(id) {
  return fetch({
    url: '/buytosend/info/' + id,
    method: 'get'
  })
}

export function editBuyAndSendStatus(params) {
  return fetch({
    url: `/buytosend/updateStatus`,
    method: 'put',
    params
  })
}

export function editBuyAndSend(data) {
  return fetch({
    url: `/buytosend/package`,
    method: 'post',
    data: data
  })
}
